import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { create, createLogo, get, update } from "../../common/agency/actions";
import {
  clearError,
  clearForm,
  clearFormPreview
} from "../../common/agency/actions";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";
import Input from "../../browser/components/Form/Input";
import Dropzone from "../../browser/components/Form/Dropzone";

const formFields = [
  "name",
  "description",
  "url",
  "agencyUrl",
  "promotedMax",
  "logoFileUID",
  "isActive"
];

class Form extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.clearError = this.clearError.bind(this);
    this.clearDropzone = this.clearDropzone.bind(this);
  }

  componentDidMount() {
    const { params, get, editForm, fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields, appPath } = this.props;
    const { create } = this.props;
    e.preventDefault();
    const values = fields.$values();

    values.promotedMax *= 1;
    const rs = await create(values);

    if (rs && rs.status === 200) {
      fields.$reset();
      this.redirect(`${appPath}/agencies/edit/${rs.body.uid}`);
    }
  }

  async update(e) {
    const { fields, params } = this.props;
    const { update, get } = this.props;
    e.preventDefault();
    const values = fields.$valuesChanged();

    if (Object.keys(values).length > 0) {
      values.uid = params.uid;

      if (values.promotedMax) {
        values.promotedMax *= 1;
      }

      const rs = await update(values);

      if (rs && (rs.status === 200 || rs.status === 204)) {
        await get({ uid: params.uid });
        fields.$reset();
      }
    }
  }

  async onDrop(files) {
    const { createLogo } = this.props;

    this.clearError("logoFileUID");

    const status = await createLogo(files);
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  clearDropzone(e) {
    const { fields, params, clearFormPreview } = this.props;

    e.stopPropagation();

    fields.$setValue("logoFileUID", "");
    clearFormPreview();
  }

  render() {
    const { apiHost, fields, form, editForm, obj } = this.props;

    let logoFileUID = null;

    if (editForm) {
      logoFileUID = fields.logoFileUID.value;
    }

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;
    return (
      <BootstrapForm onSubmit={editForm ? this.update : this.create} noValidate>
        <Container>
          <Row>
            <Col xs="6">
              <Input
                field="name"
                title="Nazwa"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "name")}
                autoFocus
                {...fields.name}
              />
              <Input
                field="url"
                title="Callback URL"
                type="url"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "url")}
                {...fields.url}
              />
              <Input
                field="agencyUrl"
                title="Strona WWW"
                type="url"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "agencyUrl")}
                {...fields.agencyUrl}
              />
              <Dropzone
                field="logoFileUID"
                title="Logo"
                loading={form.get("fileLoading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "logoFileUID")}
                placeholder="Przeciągnij logo tutaj, lub kliknij, aby wybrać plik"
                preview={
                  form.get("filePreview")
                    ? form.get("filePreview")
                    : logoFileUID
                      ? apiHost + "/v1/agency/image/" + logoFileUID
                      : null
                }
                onDrop={this.onDrop}
                onDelete={this.clearDropzone}
              />
            </Col>
            <Col xs="6">
              <Input
                field="description"
                title="Opis"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "description")}
                {...fields.description}
              />
              <Input
                labelCol="4"
                inputCol="8"
                field="promotedMax"
                title="Ilość promowanych ogłoszeń"
                type="number"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "promotedMax")}
                {...fields.promotedMax}
              />
              {editForm && (
                <Input
                  staticField
                  title="Klucz API"
                  value={obj.get("apiKey")}
                />
              )}
              {editForm && (
                <Input
                  field="isActive"
                  title="Aktywny"
                  type="checkbox"
                  loading={form.get("loading")}
                  checked={fields.isActive.value}
                  error={form.get("error")}
                  clearError={this.clearError.bind(this, "isActive")}
                  {...fields.isActive}
                />
              )}
            </Col>
            <ButtonWithLoader
              className="button-loader"
              size="lg"
              color={dirty ? "warning" : "success"}
              text={editForm ? "Zapisano" : "Wprowadź dane"}
              isLoading={form.get("loading") || form.get("fileLoading")}
              loadingText={"Zapisuję zmiany..."}
              isDirty={dirty}
              dirtyText={editForm ? "Zapisz zmiany" : "Dodaj agencję"}
            />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: "agencyForm",
  fields: formFields,
  getInitialState: ({ obj, editForm }) => {
    return {
      name: editForm ? obj.get("name") : "",
      description: editForm ? obj.get("description") : "",
      url: editForm ? obj.get("url") : "https://",
      agencyUrl: editForm ? obj.get("agencyUrl") : "https://",
      promotedMax: editForm ? obj.get("promotedMax") : 3,
      logoFileUID: editForm ? obj.getIn(["logoFile", "uid"]) : "",
      isActive: editForm ? obj.get("isActive") * 1 : false
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    form: state.agency.form,
    fields: state.fields,
    appPath: state.config.appPath
  }),
  { create, createLogo, clearError, clearForm, clearFormPreview, get, update }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/agency/Form.js